// deps
import React, { memo, ReactElement, useMemo } from "react";

// components
import PaymentGroupContainer from "@payment-ui/components/payment-group/components/Container";
import PaymentGroupTitle from "@payment-ui/components/payment-group/components/Title";
import PaymentOption from "./components/payment-option";

// interfaces
import { MorePaymentOptionsProps } from "@payment-ui/interfaces/MorePaymentOptions";
import { PaymentGroupDataDef } from "@payment-ui/interfaces/Payment";

// helpers
import { getPaymentOptions, getPaymentOptionSectionTitle } from "@payment-ui/helpers/MorePaymentOptions";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

function MorePaymentOptions(props: MorePaymentOptionsProps<PaymentGroupDataDef>): ReactElement {
    const title = useMemo(() => getPaymentOptionSectionTitle(props), [props]);
    const morePaymentOptions = useMemo(() => getPaymentOptions(props), [props]);
    const containerClass = title == null ? styles.paymentGroupWithNoTitle : undefined;

    return (
        <PaymentGroupContainer className={containerClass}>
            {title != null && (
                <PaymentGroupTitle title={title} data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.MORE_PAYMENT_OPTIONS} />
            )}
            <div className={styles.paymentGroupContainer}>
                {morePaymentOptions.map((paymentGroup, index) => {
                    const isLastElement = index === morePaymentOptions?.length - 1;
                    return (
                        <PaymentOption
                            key={paymentGroup.groupName}
                            groupData={paymentGroup}
                            onClick={props.onOptionClick}
                            onViewEnter={props.onViewEnter}
                            onViewTooltip={props.onViewTooltip}
                            otherProps={props.otherProps}
                            isLastElement={isLastElement}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}

export default memo(MorePaymentOptions);
